import cn from 'classnames/bind';
import React, { ChangeEvent, InputHTMLAttributes, ReactElement, useId } from 'react';

import { OptionLabel } from '../OptionLabel/OptionLabel';

import { OptionListHeight, OptionListProps } from './OptionList.types';
import styles from './OptionList.module.css';

const cx = cn.bind(styles);

function OptionList<T extends InputHTMLAttributes<HTMLInputElement>['value']>(
    props: OptionListProps<T>
): ReactElement<OptionListProps<T>> {
    const { options, value: listValue, onSelect, heightType } = props;
    const group = useId();

    return (
        <div
            className={cx('root', {
                'root_height-hold': heightType === OptionListHeight.Hold,
            })}
        >
            {options.map((option) => {
                const { name, value, disabled = false, note, icon, isInlineNote = false } = option;
                const isChecked = listValue ? listValue.value === value : !value;
                const handleSelect = (e: ChangeEvent<HTMLInputElement>) => {
                    const selectedItem = options.find(
                        ({ value: optionValue }) =>
                            // eslint-disable-next-line eqeqeq
                            optionValue == e.target.value
                    );

                    if (selectedItem) {
                        onSelect(selectedItem);
                    }
                };

                return (
                    <OptionLabel
                        key={name}
                        isChecked={isChecked}
                        disabled={disabled}
                        isInlineNote={isInlineNote}
                        value={value}
                        icon={icon}
                        name={name}
                        note={note}
                        group={group}
                        handleSelect={handleSelect}
                    />
                );
            })}
        </div>
    );
}

export default OptionList;
